<template lang="html">
  <div class="">
    <!-- <v-btn @click="printDiv()" elevation="1" outlined right> <v-icon left>mdi-printer</v-icon>Print</v-btn> -->
    <!-- <iframe id="iframeReceipt" name="iframeReceipt" style="height:0;width:0;"></iframe> -->
    <iframe
      id="iframeReceipt"
      name="iframeReceipt"
      style="height: 0; width: 0"
    ></iframe>
    <div ref="invoice" style="display: none" id="printableArea">
      <div>
        <v-row>
          <v-col cols="9">
            <span class="top-heading">Date:</span
            ><span>{{
              this.captureData.paymentOrderData &&
              this.captureData.paymentOrderData.updatedAt
                ? moment(this.captureData.paymentOrderData.updatedAt)
                : moment(this.captureData.paymentOrderData.updatedAt)
            }}</span>
          </v-col>
          <v-col cols="3">
            <span class="top-heading">Receipt:</span
            ><span>{{
              this.captureData.paymentOrderData &&
              this.captureData.paymentOrderData.receiptNo
                ? this.captureData.paymentOrderData.receiptNo
                : 'N/A'
            }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="3"
            class="flex-content"
            style="
              display: flex;
              margin-top: 10px;
              justify-content: center;
              align-items: center;
              text-transform: uppercase;
            "
          >
            <img width="150" :src="franchiseeLogo" alt="" />
          </v-col>
          <v-col cols="6" style="text-align: center; margin-top: 10px">
            <p class="franchisee-name">
              {{
                this.captureData.enquiryData &&
                this.captureData.enquiryData.franchisee &&
                this.captureData.enquiryData.franchisee.companyName
                  ? this.captureData.enquiryData.franchisee.companyName
                  : 'N/A'
              }}
            </p>
            <p>
              {{
                this.captureData.enquiryData &&
                this.captureData.enquiryData.franchisee &&
                this.captureData.enquiryData.franchisee.trustName
                  ? this.captureData.enquiryData.franchisee.trustName
                  : 'N/A'
              }}
            </p>
            <p
              v-if="
                this.captureData.enquiryData.franchisee &&
                this.captureData.enquiryData.franchisee.tanNo
              "
            >
              TAN No.-
              {{
                this.captureData.enquiryData &&
                this.captureData.enquiryData.franchisee &&
                this.captureData.enquiryData.franchisee.tanNo
                  ? this.captureData.enquiryData.franchisee.tanNo
                  : 'N/A'
              }}
            </p>
          </v-col>
          <v-col
            cols="3"
            class="flex-content"
            style="
              display: flex;
              margin-top: 10px;
              justify-content: center;
              align-items: center;
              text-transform: uppercase;
            "
            ><img width="150" :src="tots_image" alt=""
          /></v-col>
        </v-row>
        <v-divider
          class="divider"
          style="margin-top: 6px; border: 1px solid; border-color: black"
        ></v-divider>
        <div class="v-container">
          <v-row>
            <v-col cols="6">
              <v-row no-gutters>
                <v-col cols="4">
                  <span
                    v-if="
                      this.studentDetails && !this.studentDetails.enrollmentCode
                    "
                    ><b>Enquiry Code</b> <br
                  /></span>
                  <span><b>Student Name</b></span
                  ><br />
                  <span><b>Franchisee Name</b></span
                  ><br />
                  <span><b>Academic Year</b></span
                  ><br />
                  <span><b>Class</b></span>
                  <br />
                  <span><b>Application Code</b></span>
                  <br />
                  <span><b>Student Gender</b></span>
                  <br />
                  <span><b>Section / Division</b></span>
                  <br />
                  <span><b>Enrollment Code</b></span>
                  <br />
                  <span
                    v-if="
                      this.paymentOtherDetails &&
                      this.paymentOtherDetails.chequeNO
                    "
                    ><b>Cheque No</b> <br
                  /></span>
                  <span
                    v-if="
                      this.paymentOtherDetails &&
                      this.paymentOtherDetails.transactionID
                    "
                    ><b>Transaction ID</b><br
                  /></span>
                </v-col>
                <v-col cols="8">
                  <span
                    v-if="
                      this.studentDetails && !this.studentDetails.enrollmentCode
                    "
                    >:
                    {{
                      this.studentDetails && this.studentDetails.enquiryCode
                        ? this.studentDetails.enquiryCode
                        : 'N/A'
                    }}<br
                  /></span>
                  <span
                    >:
                    {{
                      this.studentDetails && this.studentDetails.name
                        ? this.studentDetails.name
                        : 'N/A'
                    }}</span
                  ><br />
                  <span
                    >:
                    {{
                      this.studentDetails && this.studentDetails.franchiseeName
                        ? this.studentDetails.franchiseeName
                        : 'N/A'
                    }}</span
                  ><br />
                  <span
                    >:
                    {{
                      this.studentDetails && this.studentDetails.academicYear
                        ? this.studentDetails.academicYear
                        : 'N/A'
                    }}</span
                  ><br />
                  <span
                    >:
                    {{
                      this.studentDetails && this.studentDetails.class
                        ? this.studentDetails.class
                        : 'N/A'
                    }}</span
                  ><br />
                  <span
                    >:
                    {{
                      this.studentDetails && this.studentDetails.applicationCode
                        ? this.studentDetails.applicationCode
                        : 'N/A'
                    }}</span
                  ><br />
                  <span
                    v-if="
                      studentDetails.gender === 'Female' ||
                      studentDetails.gender === 'FEMALE'
                    "
                    >:
                    {{
                      studentDetails &&
                      studentDetails.gender &&
                      studentDetails.gender === 'Female'
                        ? 'Girl'
                        : '-' ||
                          (studentDetails &&
                            studentDetails.gender &&
                            studentDetails.gender === 'FEMALE')
                        ? 'Girl'
                        : '-'
                    }}</span
                  >
                  <span
                    v-if="
                      studentDetails.gender === 'Male' ||
                      studentDetails.gender === 'MALE'
                    "
                    >:
                    {{
                      studentDetails &&
                      studentDetails.gender &&
                      studentDetails.gender === 'Male'
                        ? 'Boy'
                        : '-' ||
                          (studentDetails &&
                            studentDetails.gender &&
                            studentDetails.gender === 'MALE')
                        ? 'Boy'
                        : '-'
                    }}</span
                  >
                  <span v-if="studentDetails.gender === null" class="mb-1"
                    >: N/A</span
                  >
                  <br />
                  <span
                    >:
                    {{
                      this.studentDetails && this.studentDetails.sectionName
                        ? this.studentDetails.sectionName
                        : 'N/A'
                    }}</span
                  ><br />
                  <span
                    >:
                    {{
                      this.studentDetails && this.studentDetails.enrollmentCode
                        ? this.studentDetails.enrollmentCode
                        : 'N/A'
                    }}</span
                  ><br />
                  <span
                    v-if="
                      this.paymentOtherDetails &&
                      this.paymentOtherDetails.chequeNO
                    "
                    >:
                    {{
                      this.paymentOtherDetails &&
                      this.paymentOtherDetails.chequeNO
                        ? this.paymentOtherDetails.chequeNO
                        : 'N/A'
                    }}<br
                  /></span>
                  <span
                    v-if="
                      this.paymentOtherDetails &&
                      this.paymentOtherDetails.transactionID
                    "
                    >:
                    {{
                      this.paymentOtherDetails &&
                      this.paymentOtherDetails.transactionID
                        ? this.paymentOtherDetails.transactionID
                        : 'N/A'
                    }}<br
                  /></span>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-row no-gutters>
                <v-col cols="6" style="padding: 0 0 25px 0">
                  <div v-if="isFatherData">
                    <span><b>Father's Name</b></span
                    ><br />
                    <span><b>Father's Mobile</b></span
                    ><br />
                    <span><b>Father's Email</b></span>
                  </div>
                  <br />
                  <div v-if="isMotherData">
                    <span><b>Mother's Name</b></span
                    ><br />
                    <span><b>Mother's Mobile</b></span
                    ><br />
                    <span><b>Mother's Email</b></span>
                  </div>
                  <br />
                </v-col>
                <v-col cols="6">
                  <div v-if="isFatherData">
                    <span
                      >:
                      {{
                        this.captureData.enquiryData &&
                        this.captureData.enquiryData.fatherName
                          ? this.captureData.enquiryData.fatherName
                          : 'N/A'
                      }}</span
                    ><br />
                    <span
                      >:
                      {{
                        this.captureData.enquiryData &&
                        this.captureData.enquiryData.fatherMobile
                          ? this.captureData.enquiryData.fatherMobile
                          : 'N/A'
                      }}</span
                    ><br />
                    <span
                      >:
                      {{
                        this.captureData.enquiryData &&
                        this.captureData.enquiryData.fatherEmailID
                          ? this.captureData.enquiryData.fatherEmailID
                          : 'N/A'
                      }}</span
                    >
                  </div>
                  <br />
                  <div v-if="isMotherData">
                    <span
                      >:
                      {{
                        this.captureData.enquiryData &&
                        this.captureData.enquiryData.motherName
                          ? this.captureData.enquiryData.motherName
                          : 'N/A'
                      }}</span
                    ><br />
                    <span
                      >:
                      {{
                        this.captureData.enquiryData &&
                        this.captureData.enquiryData.motherMobile
                          ? this.captureData.enquiryData.motherMobile
                          : 'N/A'
                      }}</span
                    ><br />
                    <span
                      >:
                      {{
                        this.captureData.enquiryData &&
                        this.captureData.enquiryData.motherEmailID
                          ? this.captureData.enquiryData.motherEmailID
                          : 'N/A'
                      }}</span
                    >
                  </div>
                  <br />
                  <!-- <span>: {{ this.studentDetails && this.studentDetails.gender ? this.studentDetails.gender : 'N/A' }}</span
                  > -->
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <br />
          <table style="width:100%;border:solid 1px #000;">
            <thead>
              <tr style="border: 1px solid black">
                <th style="border: 1px solid black; padding: 5px 10px 5px 10px">
                  Sr.no
                </th>
                <th style="border: 1px solid black; padding: 5px 10px 5px 10px">
                  Particulars
                </th>

                <th style="border: 1px solid black; padding: 5px 10px 5px 10px">
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(part, index) in captureData.studentPaymentData"
                :key="part.id"
                style="border: 1px solid black"
              >
                <td style="padding: 5px 10px 5px 10px">{{ index + 1 }}</td>
                <td style="border: 1px solid black; padding: 5px 10px 5px 10px">
                  {{
                    part.assignFeeInstallment
                      ? part.assignFeeInstallment.feeTypeName +
                        ' ' +
                        part.assignFeeInstallment.name
                      : part.invoiceFeeName || 'N/A'
                  }}
                </td>

                <td style="padding: 5px 10px 5px 10px">
                  {{ part.amount ? `  ` + part.amount : '0.00' }}
                </td>
              </tr>
            </tbody>
            <tfoot class="">
              <tr>
                <th
                  style="text-align: left; border: 1px solid black"
                  colspan="2"
                >
                  Total Amount
                </th>

                <td style="padding: 5px 10px 5px 10px">
                  {{
                    this.captureData.paymentOrderData &&
                    this.captureData.paymentOrderData.amount
                      ? this.captureData.paymentOrderData.amount
                      : 'N/A'
                  }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <v-row style="margin-top: 17px">
          <v-col cols="5">
            <span
              v-if="
                this.captureData.paymentOrderData &&
                this.captureData.paymentOrderData.paymentMode
              "
              ><b>Mode of Payment</b> :
              {{
                this.captureData.paymentOrderData &&
                this.captureData.paymentOrderData.paymentMode
                  ? this.captureData.paymentOrderData.paymentMode
                  : 'N/A'
              }}</span
            >
          </v-col>
          <v-col cols="3" style="margin-right: 90px">
            <span
              v-if="
                this.captureData.paymentOrderData &&
                this.captureData.paymentOrderData.paymentMode
              "
              ><b>Internet Payment</b> :
              {{
                this.captureData.paymentOrderData &&
                this.captureData.paymentOrderData.paymentMode !== 'CASH'
                  ? this.captureData.paymentOrderData.paymentMethod
                  : 'N/A'
              }}</span
            >
          </v-col>
          <v-col cols="3">
            <span
              v-if="
                this.captureData.paymentOrderData &&
                this.captureData.paymentOrderData.paymentMode
              "
              ><b>Date of Payment</b> :
              {{
                this.captureData.paymentOtherData &&
                this.captureData.paymentOtherData.dateOfPayment
                  ? moment(this.captureData.paymentOtherData.dateOfPayment)
                  : moment(this.captureData.paymentOrderData.updatedAt)
              }}</span
            >
          </v-col>
          <v-col cols="6"></v-col>
          <v-col cols="12" class="cashier">
            <span>Cashier / Manager</span>
          </v-col>
          <v-col cols="10" style="padding: 25px 0 0px 25px">
            <span class="note"
              >Note : Parents are requested to preserve this receipt for future
              clarifications in respect of fee paid by you. Fee once paid will
              not be refunded or transferred.Cheques subject to
              realization.</span
            >
          </v-col>
        </v-row>
      </div>
    </div>
    <div ref="invoice" style="display: none" id="printableArea1">
      <div>
        <v-row>
          <v-col cols="6">
            <span class="top-heading">Date:</span
            ><span>{{
              this.captureData.paymentOrderData &&
              this.captureData.paymentOrderData.updatedAt
                ? new Date(
                    this.captureData.paymentOrderData.updatedAt
                  ).toLocaleString()
                : ''
            }}</span>
          </v-col>
          <v-col cols="6">
            <span class="top-heading">Receipt:</span
            ><span>{{
              this.captureData.paymentOrderData &&
              this.captureData.paymentOrderData.receiptNo
                ? this.captureData.paymentOrderData.receiptNo
                : 'N/A'
            }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3" class="flex-content"
            ><img width="100" :src="franchiseeLogo" alt="Logo of Franchisee"
          /></v-col>
          <v-col cols="6" style="text-align: center">
            <p class="franchisee-name">
              {{
                this.captureData.enquiryData &&
                this.captureData.enquiryData.franchisee &&
                this.captureData.enquiryData.franchisee.companyName
                  ? this.captureData.enquiryData.franchisee.companyName
                  : 'N/A'
              }}
            </p>
            <p>
              {{
                this.captureData.enquiryData &&
                this.captureData.enquiryData.franchisee &&
                this.captureData.enquiryData.franchisee.trustName
                  ? this.captureData.enquiryData.franchisee.trustName
                  : 'N/A'
              }}
            </p>
          </v-col>

          <v-col cols="3" class="flex-content"
            ><img width="100" :src="tots_image" alt=""
          /></v-col>
        </v-row>
        <v-divider class="divider"></v-divider>
        <div class="v-container">
          <v-row>
            <v-col cols="6">
              <v-row no-gutters>
                <v-col cols="4">
                  <span
                    v-if="
                      this.studentDetails && !this.studentDetails.enrollmentCode
                    "
                    ><b>Enquiry Code</b> <br
                  /></span>
                  <span><b>Student Name</b></span
                  ><br />
                  <span><b>Franchisee Name</b></span
                  ><br />
                  <span><b>Academic Year</b></span
                  ><br />
                  <span><b>Class</b></span>
                  <br />
                  <span><b>Application Code</b></span>
                  <br />
                  <span><b>Student Gender</b></span>
                  <br />
                  <span><b>Section / Division</b></span>
                  <br />
                  <span><b>Enrollment Code</b></span>
                  <br />
                  <span
                    v-if="
                      this.paymentOtherDetails &&
                      this.paymentOtherDetails.chequeNO
                    "
                    ><b>Cheque No</b> <br
                  /></span>
                  <span
                    v-if="
                      this.paymentOtherDetails &&
                      this.paymentOtherDetails.transactionID
                    "
                    ><b>Transaction ID</b><br
                  /></span>
                </v-col>
                <v-col cols="8">
                  <span
                    v-if="
                      this.studentDetails && !this.studentDetails.enrollmentCode
                    "
                    >:
                    {{
                      this.studentDetails && this.studentDetails.enquiryCode
                        ? this.studentDetails.enquiryCode
                        : 'N/A'
                    }}<br
                  /></span>
                  <span
                    >:
                    {{
                      this.studentDetails && this.studentDetails.name
                        ? this.studentDetails.name
                        : 'N/A'
                    }}</span
                  ><br />
                  <span
                    >:
                    {{
                      this.studentDetails && this.studentDetails.franchiseeName
                        ? this.studentDetails.franchiseeName
                        : 'N/A'
                    }}</span
                  ><br />
                  <span
                    >:
                    {{
                      this.studentDetails && this.studentDetails.academicYear
                        ? this.studentDetails.academicYear
                        : 'N/A'
                    }}</span
                  ><br />
                  <span
                    >:
                    {{
                      this.studentDetails && this.studentDetails.class
                        ? this.studentDetails.class
                        : 'N/A'
                    }}</span
                  ><br />
                  <span
                    >:
                    {{
                      this.studentDetails && this.studentDetails.applicationCode
                        ? this.studentDetails.applicationCode
                        : 'N/A'
                    }}</span
                  >
                  <br />
                  <span
                    v-if="
                      studentDetails.gender === 'Female' ||
                      studentDetails.gender === 'FEMALE'
                    "
                    >:
                    {{
                      studentDetails &&
                      studentDetails.gender &&
                      studentDetails.gender === 'Female'
                        ? 'Girl'
                        : '-' ||
                          (studentDetails &&
                            studentDetails.gender &&
                            studentDetails.gender === 'FEMALE')
                        ? 'Girl'
                        : '-'
                    }}</span
                  >
                  <span
                    v-if="
                      studentDetails.gender === 'Male' ||
                      studentDetails.gender === 'MALE'
                    "
                    >:
                    {{
                      studentDetails &&
                      studentDetails.gender &&
                      studentDetails.gender === 'Male'
                        ? 'Boy'
                        : '-' ||
                          (studentDetails &&
                            studentDetails.gender &&
                            studentDetails.gender === 'MALE')
                        ? 'Boy'
                        : '-'
                    }}</span
                  >
                  <span v-if="studentDetails.gender === null" class="mb-1"
                    >: N/A</span
                  >
                  <br />
                  <span
                    >:
                    {{
                      this.studentDetails && this.studentDetails.sectionName
                        ? this.studentDetails.sectionName
                        : 'N/A'
                    }}</span
                  ><br />
                  <span
                    >:
                    {{
                      this.studentDetails && this.studentDetails.enrollmentCode
                        ? this.studentDetails.enrollmentCode
                        : 'N/A'
                    }}</span
                  ><br />
                  <span
                    v-if="
                      this.paymentOtherDetails &&
                      this.paymentOtherDetails.chequeNO
                    "
                    >:
                    {{
                      this.paymentOtherDetails &&
                      this.paymentOtherDetails.chequeNO
                        ? this.paymentOtherDetails.chequeNO
                        : 'N/A'
                    }}<br
                  /></span>
                  <span
                    v-if="
                      this.paymentOtherDetails &&
                      this.paymentOtherDetails.transactionID
                    "
                    >:
                    {{
                      this.paymentOtherDetails &&
                      this.paymentOtherDetails.transactionID
                        ? this.paymentOtherDetails.transactionID
                        : 'N/A'
                    }}<br
                  /></span>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-row no-gutters>
                <v-col cols="6">
                  <div v-if="isFatherData">
                    <span><b>Father's Name</b></span
                    ><br />
                    <span><b>Father's Mobile</b></span
                    ><br />
                    <span><b>Father's Email</b></span>
                  </div>
                  <br />
                  <div v-if="isMotherData">
                    <span><b>Mother's Name</b></span
                    ><br />
                    <span><b>Mother's Mobile</b></span
                    ><br />
                    <span><b>Mother's Email</b></span>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div v-if="isFatherData">
                    <span
                      >:
                      {{
                        this.captureData.enquiryData &&
                        this.captureData.enquiryData.fatherName
                          ? this.captureData.enquiryData.fatherName
                          : 'N/A'
                      }}</span
                    ><br />
                    <span
                      >:
                      {{
                        this.captureData.enquiryData &&
                        this.captureData.enquiryData.fatherMobile
                          ? this.captureData.enquiryData.fatherMobile
                          : 'N/A'
                      }}</span
                    ><br />
                    <span
                      >:
                      {{
                        this.captureData.enquiryData &&
                        this.captureData.enquiryData.fatherEmailID
                          ? this.captureData.enquiryData.fatherEmailID
                          : 'N/A'
                      }}</span
                    >
                  </div>
                  <br />
                  <div v-if="isMotherData">
                    <span
                      >:
                      {{
                        this.captureData.enquiryData &&
                        this.captureData.enquiryData.motherName
                          ? this.captureData.enquiryData.motherName
                          : 'N/A'
                      }}</span
                    ><br />
                    <span
                      >:
                      {{
                        this.captureData.enquiryData &&
                        this.captureData.enquiryData.motherMobile
                          ? this.captureData.enquiryData.motherMobile
                          : 'N/A'
                      }}</span
                    ><br />
                    <span
                      >:
                      {{
                        this.captureData.enquiryData &&
                        this.captureData.enquiryData.motherEmailID
                          ? this.captureData.enquiryData.motherEmailID
                          : 'N/A'
                      }}</span
                    ><br />
                    <!-- <span>: {{ this.studentDetails && this.studentDetails.gender ? this.studentDetails.gender : 'N/A' }}</span
                  > -->
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <table style="width:100%;border:solid 1px #000;">
            <thead>
              <tr>
                <th>S.no</th>
                <th>Particulars</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(part, index) in captureData.studentPaymentData"
                :key="part.id"
              >
                <td>{{ index + 1 }}</td>
                <td>
                  {{
                    part.assignFeeInstallment
                      ? part.assignFeeInstallment.feeTypeName +
                        '  ' +
                        part.assignFeeInstallment.name
                      : part.invoiceFeeName || 'N/A'
                  }}
                </td>
                <td>{{ part.amount ? `    ${part.amount}` : '0.00' }}</td>
              </tr>
            </tbody>
            <tfoot class="">
              <tr>
                <th style="text-align: right" colspan="2">Total Amount</th>
                <td>
                  {{
                    this.captureData.paymentOrderData &&
                    this.captureData.paymentOrderData.amount
                      ? this.captureData.paymentOrderData.amount
                      : 'N/A'
                  }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <v-row>
          <v-col cols="4">
            <span
              v-if="
                this.captureData.paymentOrderData &&
                this.captureData.paymentOrderData.paymentMode
              "
              ><b>Mode of Payment</b> :
              {{
                this.captureData.paymentOrderData &&
                this.captureData.paymentOrderData.paymentMode
                  ? this.captureData.paymentOrderData.paymentMode
                  : 'N/A'
              }}</span
            >
          </v-col>
          <v-col cols="4">
            <span
              v-if="
                this.captureData.paymentOrderData &&
                this.captureData.paymentOrderData.paymentMode
              "
              ><b>Internet Payment</b> :
              {{
                this.captureData.paymentOrderData &&
                this.captureData.paymentOrderData.paymentMode !== 'CASH'
                  ? this.captureData.paymentOrderData.paymentMethod
                  : 'N/A'
              }}</span
            >
          </v-col>
          <v-col cols="4">
            <span
              v-if="
                this.captureData.paymentOrderData &&
                this.captureData.paymentOrderData.paymentMode
              "
              ><b>Date of Payment</b> :
              {{
                this.captureData.paymentOtherData &&
                this.captureData.paymentOtherData.dateOfPayment
                  ? moment(this.captureData.paymentOtherData.dateOfPayment)
                  : moment(this.captureData.paymentOrderData.updatedAt)
              }}</span
            >
          </v-col>
          <v-col cols="6"></v-col>
          <v-col cols="12" class="cashier">
            <span>Cashier / Manager</span>
          </v-col>
          <v-col cols="12">
            <span class="note"
              >Note: Parents are requested to preserve this receipt for future
              clarifications in respect of fee paid by you. Fee once paid will
              not be refunded or transferred.Cheques subject to
              realization.</span
            >
          </v-col>
        </v-row>
      </div>
    </div>
    <div ref="invoice" style="display: none" id="printableArea2">
      <div>
        <v-row>
          <v-col cols="9">
            <span class="top-heading">Date of Invoice:</span
            ><span>{{
              this.captureData.paymentOrderData &&
              this.captureData.paymentOrderData.updatedAt
                ? moment(this.captureData.paymentOrderData.updatedAt,'printableArea2')
                : moment(this.captureData.paymentOrderData.updatedAt,'printableArea2')
            }}</span>
          </v-col>
          <v-col cols="3">
            <span class="top-heading">Invoice Number:</span
            ><span>{{
              this.gstCalculationData &&
              this.gstCalculationData.invoiceNumber
                ? this.gstCalculationData.invoiceNumber
                : 'N/A'
            }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="3"
            class="flex-content"
            style="
              display: flex;
              margin-top: 10px;
              justify-content: center;
              align-items: center;
              text-transform: uppercase;
            "
          >
            <img width="150" :src="franchiseeLogo" alt="" />
          </v-col>
          <v-col cols="6" style="text-align: center; margin-top: 10px">
            <p><b>Tax Invoice</b></p>

          </v-col>
          <v-col
            cols="3"
            class="flex-content"
            style="
              display: flex;
              margin-top: 10px;
              justify-content: center;
              align-items: center;
              text-transform: uppercase;
            "
            ><img width="150" :src="tots_image" alt=""
          /></v-col>
        </v-row>
        <v-divider
          class="divider"
          style="margin-top: 6px; border: 1px solid; border-color: black"
        ></v-divider>
        <div class="v-container">
          <v-row>
            <v-col cols="6">
              <v-row no-gutters>
                <v-col cols="4">

                  <span><b>To ,</b></span
                  ><br /><br />
                  <span>Student Name</span
                  ><br />
                  <span>Student Address</span
                  ><br />

                </v-col>
                <v-col cols="8">

                  <span></span><br /><br />
                  <span
                    >:
                    {{
                      this.studentDetails && this.studentDetails.name
                        ? this.studentDetails.name
                        : 'N/A'
                    }}</span
                  ><br />
                  <span v-if="this.captureData.enquiryData.address1 !== ''">
                    : {{ this.captureData.enquiryData.address1  }}
                  </span>
                  <span v-else>
                    : N/A
                  </span><br />

                </v-col>

                <span>Place of Supply</span
                >
                <span style="margin-left :11.5%"
                  >:
                  {{
                    this.captureData.enquiryData.franchisee && this.captureData.enquiryData.franchisee.state
                    ? this.captureData.enquiryData.franchisee.state
                    : 'N/A'
                  }}</span
                >

              </v-row>
            </v-col>
            <v-col cols="6">
              <span><b>From ,</b></span>
              <br /><br />
              <span>
                {{
                  this.captureData.enquiryData &&
                  this.captureData.enquiryData.franchisee &&
                  this.captureData.enquiryData.franchisee.trustName
                    ? this.captureData.enquiryData.franchisee.trustName
                    : 'N/A'
                }}
              </span><br />
              <v-row no-gutters>
                <v-col cols="3">

                    <span>Name</span
                    ><br />
                    <span>Address</span
                    ><br />

                  <br />
                </v-col>
                <v-col cols="9">

                  <span
                    >:
                    {{
                      this.captureData.enquiryData && this.captureData.enquiryData.franchisee.companyName
                        ? this.captureData.enquiryData.franchisee.companyName
                        : 'N/A'
                    }}</span
                  ><br />
                  <span style="text-align: justify;"
                    >:
                    {{
                      this.captureData.enquiryData.franchisee && this.captureData.enquiryData.franchisee.address1
                        ? this.captureData.enquiryData.franchisee.address1
                        : 'N/A'
                    }}</span
                  ><br />

                </v-col>

                <span>GSTIN</span>
                <span style="margin-left :16%"
                  >:
                  {{
                    this.captureData.enquiryData.franchisee && this.captureData.enquiryData.franchisee.gstNo
                      ? this.captureData.enquiryData.franchisee.gstNo
                      : 'N/A'
                  }}</span
                >
              </v-row>
            </v-col>
          </v-row>

          <v-divider
            class="divider"
            style="margin-top: 6px; border: 1px solid; border-color: black"
          ></v-divider>

          <div class="v-container" style="padding:15px; border: 1px solid black;">
            <v-row>
              <v-col cols="6">
                <v-row no-gutters>
                  <v-col cols="4">
                    <span><b>Academic Year</b></span
                    ><br />
                    <span><b>Class</b></span>
                    <br />
                    <span><b>Application Code</b></span>
                    <br />
                    <span><b>Student Gender</b></span>
                    <br />
                    <span><b>Section / Division</b></span>
                    <br />
                  </v-col>
                  <v-col cols="8">
                    <span
                      >:
                      {{
                        this.studentDetails && this.studentDetails.academicYear
                          ? this.studentDetails.academicYear
                          : 'N/A'
                      }}</span
                    ><br />
                    <span
                      >:
                      {{
                        this.studentDetails && this.studentDetails.class
                          ? this.studentDetails.class
                          : 'N/A'
                      }}</span
                    ><br />
                    <span
                      >:
                      {{
                        this.studentDetails && this.studentDetails.applicationCode
                          ? this.studentDetails.applicationCode
                          : 'N/A'
                      }}</span
                    ><br />
                    <span
                      v-if="
                        this.captureData.enquiryData.gender === 'Female' ||
                        this.captureData.enquiryData.gender === 'FEMALE'
                      "
                      >:
                      {{
                        this.captureData.enquiryData &&
                        this.captureData.enquiryData.gender &&
                        this.captureData.enquiryData.gender === 'Female'
                          ? 'Girl'
                          : '-' ||
                            (this.captureData.enquiryData &&
                              this.captureData.enquiryData.gender &&
                              this.captureData.enquiryData.gender === 'FEMALE')
                          ? 'Girl'
                          : '-'
                      }}</span
                    >
                    <span
                      v-if="
                        this.captureData.enquiryData.gender === 'Male' ||
                        this.captureData.enquiryData.gender === 'MALE'
                      "
                      >:
                      {{
                        this.captureData.enquiryData &&
                        this.captureData.enquiryData.gender &&
                        this.captureData.enquiryData.gender === 'Male'
                          ? 'Boy'
                          : '-' ||
                            (this.captureData.enquiryData &&
                              this.captureData.enquiryData.gender &&
                              this.captureData.enquiryData.gender === 'MALE')
                          ? 'Boy'
                          : '-'
                      }}</span
                    >
                    <span v-if="this.captureData.enquiryData.gender === null || this.captureData.enquiryData.gender === ''" class="mb-1"
                      >: N/A</span
                    >
                    <br />

                    <span
                      >:
                      {{
                        this.studentDetails && this.studentDetails.sectionName
                        ? this.studentDetails.sectionName
                        : (this.captureData.enquiryData && this.captureData.enquiryData.section
                          ? this.captureData.enquiryData.section
                          : 'N/A')
                      }}</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-row no-gutters>
                  <v-col cols="4" style="padding: 0 0 25px 0">
                    <span><b>Father's Name</b></span
                    ><br />
                    <span><b>Father's Mobile</b></span
                    ><br />
                    <span><b>Father's Email</b></span>
                    <br />
                    <span><b>Enrollment Code</b></span>
                    <br />
                    <span><b>Transaction ID</b></span>
                    <br />
                  </v-col>
                  <v-col cols="7">
                    <span
                      >:
                      {{
                        this.captureData.enquiryData &&
                        this.captureData.enquiryData.fatherName
                          ? this.captureData.enquiryData.fatherName
                          : 'N/A'
                      }}</span
                    ><br />
                    <span
                      >:
                      {{
                        this.captureData.enquiryData &&
                        this.captureData.enquiryData.fatherMobile
                          ? this.captureData.enquiryData.fatherMobile
                          : 'N/A'
                      }}</span
                    ><br />
                    <span
                      >:
                      {{
                        this.captureData.enquiryData &&
                        this.captureData.enquiryData.fatherEmailID
                          ? this.captureData.enquiryData.fatherEmailID
                          : 'N/A'
                      }}</span
                    ><br />
                    <span
                    >:
                    {{
                      this.studentDetails && this.studentDetails.enrollmentCode
                        ? this.studentDetails.enrollmentCode
                        : 'N/A'
                    }}</span
                  ><br />

                  <span>:
                    {{
                      this.paymentOtherDetails &&
                      this.paymentOtherDetails.transactionID
                        ? this.paymentOtherDetails.transactionID
                        : 'N/A'
                    }}<br
                  /></span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>

          <br />
          <table style="width:100%;border:solid 1px #000;">
            <thead>
              <tr style="border: 1px solid black; text-align: center">
                <th rowspan="2"  style="border: 1px solid black; padding: 5px 10px 5px 10px">
                  Item Code
                </th>
                <th rowspan="2"  style="border: 1px solid black; padding: 5px 10px 5px 10px">
                  Item Name
                </th>
                <th rowspan="2"  style="border: 1px solid black; padding: 5px 10px 5px 10px">
                  SAC Code
                </th>
                <th rowspan="2"  style="border: 1px solid black; padding: 5px 10px 5px 10px">
                  Qty
                </th>
                <th rowspan="2"  style="border: 1px solid black; padding: 5px 10px 5px 10px">
                  Taxable
                </th>
                <th colspan="2" style="border: 1px solid black; padding: 5px 10px 5px 10px">
                  CGST
                </th>
                <th colspan="2" style="border: 1px solid black; padding: 5px 10px 5px 10px">
                  SGST
                </th>
                <th rowspan="2" style="border: 1px solid black; padding: 5px 10px 5px 10px">
                  Total (Including Tax)
                </th>
              </tr>
              <tr style="text-align: center">
                <td style="border: 1px solid black; padding: 5px 10px 5px 10px">Rate</td>
                <td style="border: 1px solid black; padding: 5px 10px 5px 10px">Amount</td>
                <td style="border: 1px solid black; padding: 5px 10px 5px 10px">Rate</td>
                <td style="border: 1px solid black; padding: 5px 10px 5px 10px">Amount</td>
              </tr>
            </thead>
            <tbody>
              <tr style="text-align: center">
                <td style="padding: 5px 10px 5px 10px">{{ 1 }}</td>
                <td style="border: 1px solid black; padding: 5px 10px 5px 10px">{{ captureData.studentPaymentData[0].invoiceFeeName }}</td>
                <td style="border: 1px solid black; padding: 5px 10px 5px 10px">{{ gstCalculationData.sacCode }}</td>
                <td style="border: 1px solid black; padding: 5px 10px 5px 10px">{{ gstCalculationData.qty }}</td>
                <td style="border: 1px solid black; padding: 5px 10px 5px 10px">{{ gstCalculationData.taxableAmount }}</td>
                <td style="border: 1px solid black; padding: 5px 10px 5px 10px">{{ gstCalculationData.cgstRate }}</td>
                <td style="border: 1px solid black; padding: 5px 10px 5px 10px">{{ gstCalculationData.cgstAmount }}</td>
                <td style="border: 1px solid black; padding: 5px 10px 5px 10px">{{ gstCalculationData.sgstRate }}</td>
                <td style="border: 1px solid black; padding: 5px 10px 5px 10px">{{ gstCalculationData.sgstAmount }}</td>
                <td style="border: 1px solid black; padding: 5px 10px 5px 10px">{{ captureData.studentPaymentData[0].amount }}</td>

              </tr>
              <tr></tr>
            </tbody>
            <tfoot class="">
              <tr>
                <th
                  style="text-align: left; border: 1px solid black; padding-left: 20px;"
                  colspan="9"
                >
                  Total SGST Amount
                </th>

                <td style="border: 1px solid black; padding: 5px 10px 5px 10px; text-align: center">
                  {{
                    this.gstCalculationData &&
                    this.gstCalculationData.sgstAmount
                      ? this.gstCalculationData.sgstAmount
                      : 'N/A'
                  }}
                </td>
              </tr>
              <tr>
                <th
                  style="text-align: left; border: 1px solid black; padding-left: 20px;"
                  colspan="9"
                >
                Total CGST Amount
                </th>

                <td style="border: 1px solid black; padding: 5px 10px 5px 10px; text-align: center">
                  {{
                    this.gstCalculationData &&
                    this.gstCalculationData.cgstAmount
                      ? this.gstCalculationData.cgstAmount
                      : 'N/A'
                  }}
                </td>
              </tr>
              <tr>
                <th
                  style="text-align: left; border: 1px solid black; padding-left: 20px;"
                  colspan="9"
                >
                Grand Total
                </th>

                <td style="border: 1px solid black; padding: 5px 10px 5px 10px; text-align: center">
                  {{
                    this.captureData.studentPaymentData &&
                    this.captureData.studentPaymentData[0].amount
                      ? this.captureData.studentPaymentData[0].amount
                      : 'N/A'
                  }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <v-row style="margin-top: 17px">
          <v-col cols="12" sm="5">
            <span
              v-if="
                this.captureData.paymentOrderData &&
                this.captureData.paymentOrderData.paymentMode
              "
              ><b class="text-left">Mode of Payment</b> :
              {{
                this.captureData.paymentOrderData &&
                this.captureData.paymentOrderData.paymentMode
                  ? this.captureData.paymentOrderData.paymentMode
                  : 'N/A'
              }}</span
            >
          </v-col>
          <v-col cols="12" sm="3" style="margin-right: 90px">
            <span
              v-if="
                this.captureData.paymentOrderData &&
                this.captureData.paymentOrderData.paymentMode
              "
              ><b>Internet Payment</b> :
              {{
                this.captureData.paymentOrderData &&
                this.captureData.paymentOrderData.paymentMode !== 'CASH'
                  ? this.captureData.paymentOrderData.paymentMethod
                  : 'N/A'
              }}</span
            >
          </v-col>
          <v-col cols="12" sm="3">
            <span
              v-if="
                this.captureData.paymentOrderData &&
                this.captureData.paymentOrderData.paymentMode
              "
              ><b>Date of Payment</b> :
              {{
                this.captureData.paymentOtherData &&
                this.captureData.paymentOtherData.dateOfPayment
                  ? moment(this.captureData.paymentOtherData.dateOfPayment,'printableArea2')
                  : moment(this.captureData.paymentOrderData.updatedAt,'printableArea2')
              }}</span
            >
          </v-col>
          <!-- <v-col cols="6"></v-col> -->

          <v-col cols="12" sm="5" style="margin-top: 40px">
            <span><b>Cashier / Manager</b></span>
          </v-col>
          <v-col cols="12" sm="3" style="margin-right: 90px"></v-col>
          <v-col cols="12" sm="3" style="margin-top: 40px">
            <span>
              <b>Customer Care</b>:
                {{
                  this.gstCalculationData &&
                  this.gstCalculationData.customerCareNumber
                    ? this.gstCalculationData.customerCareNumber
                    : 'N/A'
                }}
            </span>
          </v-col>

          <!-- <v-col cols="12" class="cashier">
            <v-col cols="6">
              <span>Cashier / Manager</span>
            </v-col>
            <v-col cols="6">
              <span><b>Customer Care</b></span>
          </v-col>
          </v-col> -->
          <v-col cols="10" style="padding: 25px 0 0px 25px">
            <span class="note"
              >Note : Parents are requested to preserve this receipt for future
              clarifications in respect of fee paid by you. Fee once paid will
              not be refunded or transferred. Cheques subject to
              realization.</span
            >
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import moment from 'moment'
export default {
  name: 'Invoice',
  props: ['sendCaptureRespos'],
  data () {
    return {
      captureData: [],
      tots_image: `${constants.RAZORPAY.TOTS_IMAGE}`,
      digitValue: 0,
      floatValue: 0,
      studentDetails: '',
      paymentOtherDetails: '',
      franchiseeLogo: '',
      studentData: '',
      isMotherData: false,
      isFatherData: false,
      gstCalculationData: '',
      franchiseeInfo: '',
      studentFullName: ''
    }
  },

  async created () {
    await this.getInvoiceData()
    if (this.franchiseeLogo) {
      console.log(`Franchisee Logo: ${this.franchiseeLogo}`)
      if (!this.franchiseeLogo.includes('https')) {
        // If logo is not converted to signed URL in the backend
        this.franchiseeLogo = await this.getS3Url(this.franchiseeLogo)
      }
    } else {
      this.franchiseeLogo = `${constants.RAZORPAY.TOTS_IMAGE}`
    }
  },
  methods: {
    moment: function (value) {
      return moment(value).format('DD/MM/YYYY')
    },
    getInvoiceData: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        this.captureData = this.sendCaptureRespos.data
        if (this.sendCaptureRespos.data.gstCalculationData) {
          this.gstCalculationData = this.sendCaptureRespos.data.gstCalculationData
        }
        if (
          this.captureData &&
          this.captureData.enquiryData.franchisee.franchiseeLogo
        ) {
          this.franchiseeLogo =
            this.captureData.enquiryData.franchisee.franchiseeLogo
        }
        this.franchiseeInfo = this.captureData.enquiryData.franchisee
        this.studentData = this.sendCaptureRespos.studentInfo
        this.studentDetails = this.captureData.paymentOrderData.notes
        console.log(this.studentDetails, 'this.studentDetails')
        this.paymentOtherDetails = this.captureData.paymentOtherData
        this.captureData.paymentOrderData.amount = (
          this.captureData.paymentOrderData.amount / 100
        ).toFixed(2)
        if (this.captureData.enquiryData.motherName) {
          this.isMotherData = true
        }
        if (this.captureData.enquiryData.fatherName) {
          this.isFatherData = true
        }
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getS3Url: async function (key) {
      try {
        let response = await http.get(
          `${constants.API_URL}/api/ticket/downloadurl?s3urlKey=${key}`
        )
        return response.data
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('error', errorMessage)
        return errorMessage
      }
    }
  }
}
</script>

<style scoped>
@page {
  size: auto;
  margin: 5mm;
}
.note {
  font-size: 10px !important;
  font-weight: 500 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.cashier {
  text-align: right !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.cash {
  font-size: 14px !important;
  font-weight: 500;
}
.v-container {
  padding-left: 8px !important;
  padding-right: 8px !important;
}
.top-heading {
  margin-right: 4px !important;
}
.franchisee-name {
  font-size: 16px !important;
}
.flex-content {
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
}
table {
  padding: 2px !important;
}
table tr td,
table tr th {
  border: 1px solid #000 !important;
  font-size: 12px !important;
  color: #000 !important;
  padding: 2px !important;
}
span {
  color: #000 !important;
}
.text {
  font-size: 12px;
}
.dotted {
  border-bottom-style: dotted;
}
.divider {
  margin-top: 6px;
  margin-bottom: 0;
  background: #000 !important;
  color: #000 !important;
  border: 1px solid #000 !important;
}
@media print {
  #printableArea,
  #printableArea * {
    visibility: visible;
  }
  #printableArea {
    position: absolute;
    left: 0;
    top: 0;
  }
  #printableArea1,
  #printableArea1 * {
    visibility: visible;
  }
  #printableArea1 {
    position: absolute;
    left: 0;
    top: 0;
  }
  #printableArea2,
  #printableArea2 * {
    visibility: visible;
  }
  #printableArea2 {
    position: absolute;
    left: 0;
    top: 0;
  }
  .text-left {
    text-align: left;
  }
}
.text-justify {
  text-align: justify;
}
</style>
